import { Suspense } from 'react';

import Loader from 'src/components/Loader/Loader';

export const Suspender = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<Loader />}>{children}</Suspense>
);
